var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow-md rounded-lg p-6 bg-white w-96"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }